module.exports = __webpack_public_path__ + "static/media/empresa7.7b786566.jpg";